export default "__VITE_ASSET__BkYIUyRw__"